import GeomTool from '../geom/GeomTool';
import MathTool from '../math/MathTool';
import Bristle from './Bristle'

export default class RoundBrush{
    constructor( color, size, numBristles, minBristleSize, maxBristleSize, brightVariation=0.5 ){
        this.setColor(color);
        this.setSize( size );
        this.minBristleSize = minBristleSize;
        this.maxBristleSize = maxBristleSize;
        this.setBrightVariation( brightVariation );
        this.setNumBristles( numBristles );
        this.noiseOffset = MathTool.random()*1000000
        console.log( "Bristle constructor" );
    }

    setColor( color ){
        this.color = color;
    }
    setSize( size ){
        this.size = size;
    }
    setNumBristles( numBristles ){
        this.numBristles = numBristles;
        this.bristles = [];
        for (let i = 0; i < numBristles; i++) {
            let pos = GeomTool.randomPointInCircle( this.size, 0, 0 );
            let bristleSize = this.minBristleSize+MathTool.random()*(this.maxBristleSize-this.minBristleSize);
            //console.log( "bristleSize: ", bristleSize );
            const bristle = new Bristle( this.color, bristleSize, pos, this.brightVariation);
            this.bristles.push( bristle );            
        }
    }
    setBrightVariation( brightVariation ){
        this.brightVariation = brightVariation;
    }

    /* line( p0, p1 ){        
        let dist = MathTool.distance( p0, p1 );
        //console.log( "numPoints: ", slices);
        for (let i = 0; i < dist; i++) {
            let x = p5App.lerp( p0.x, p1.x, i/dist);
            let y = p5App.lerp( p0.y, p1.y, i/dist);
            this.paint( x, y );           
        }
    } */

    paintGesture( pts ){
        //p5App.push();
        for (let j = 0; j <this.bristles.length; j++) {
            const bristle = this.bristles[j];
            bristle.paintGesture( pts );
        }
        //p5App.pop();
    }

    paintPoints( points ){        
        //console.log( "numPoints: ", slices);
        for (let i = 0; i < points.length; i++) {
            let pt = points[i];
            this.paint( pt.x, pt.y );           
        }
    }

    paint(x, y){
        p5App.push();
        p5App.translate( x, y)
        p5App.fill( this.color );    
        for (let j = 0; j <this.bristles.length; j++) {
            const bristle = this.bristles[j];
            bristle.paint();
        }
        p5App.pop();

    }
}